import './App.css';
import AppRouter from './Components/Router/AppRouter';

import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <div className="App">
     <AppRouter />
    </div>
  );
}

export default App;
